import { useEffect } from 'preact/hooks';
import { useLocation } from 'preact-iso';
import { useAuth } from '../hooks/useAuth.jsx';

export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const { route } = useLocation();

  useEffect(() => {
    if (!loading && !user) route('/login', true);
  }, [loading, user, route]);

  if (loading) {
    return (
      <div class="flex min-h-screen items-center justify-center text-text-tertiary">
        Loading…
      </div>
    );
  }
  if (!user) return null;
  return children;
};
